import LegalNavbar from '../../components/feature/LegalNavbar';
import LegalFooter from '../../components/feature/LegalFooter';

const SECTIONS = [
  {
    title: '1. Responsable del Tratamiento',
    content: (
      <div className="space-y-2 text-gray-600 text-sm leading-relaxed">
        <p>En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le informamos:</p>
        <ul className="mt-4 space-y-2">
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[160px]">Responsable:</strong><span>Jaime Garcia Larrache Olalquia</span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[160px]">N.I.F.:</strong><span>50829100C</span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[160px]">Domicilio:</strong><span>C/ Zurbano 96, 6º Derecha, 28003 Madrid</span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[160px]">Correo electrónico:</strong><span><a href="mailto:jlarrache@mediatioglobal.com" className="text-[#3D9E8C] hover:underline">jlarrache@mediatioglobal.com</a></span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[160px]">Teléfono:</strong><span><a href="tel:+34696342047" className="text-[#3D9E8C] hover:underline">(+34) 696 342 047</a></span></li>
        </ul>
      </div>
    ),
  },
  {
    title: '2. Datos personales que tratamos',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>A través de los formularios y canales de contacto de nuestro sitio web podemos recopilar los siguientes datos personales:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li><strong>Datos identificativos:</strong> nombre, apellidos, DNI/NIE (cuando sea necesario).</li>
          <li><strong>Datos de contacto:</strong> dirección de correo electrónico, número de teléfono, dirección postal.</li>
          <li><strong>Datos del caso:</strong> descripción del conflicto o asunto a tratar, de forma voluntaria por el usuario.</li>
          <li><strong>Datos de navegación:</strong> dirección IP, tipo de navegador, páginas visitadas, duración de la visita (a través de cookies analíticas).</li>
        </ul>
        <p className="mt-3">No se recaban ni tratan datos de categorías especiales (art. 9 RGPD), salvo que el usuario los facilite voluntariamente y de forma explícita.</p>
      </div>
    ),
  },
  {
    title: '3. Finalidad del tratamiento',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>Tratamos sus datos con las siguientes finalidades:</p>
        <ul className="list-disc pl-5 space-y-2 mt-2">
          <li><strong>Atender consultas y solicitudes:</strong> gestionar la consulta gratuita inicial y dar respuesta a los mensajes enviados a través del formulario de contacto.</li>
          <li><strong>Prestación del servicio de mediación:</strong> gestionar los expedientes de mediación, coordinar las sesiones y elaborar el acuerdo final.</li>
          <li><strong>Comunicaciones informativas:</strong> envío de información sobre nuestros servicios, si el usuario ha prestado su consentimiento expreso.</li>
          <li><strong>Cumplimiento de obligaciones legales:</strong> conservar la documentación exigida por la normativa vigente aplicable a la actividad de mediación.</li>
          <li><strong>Mejora del sitio web:</strong> análisis estadístico de la navegación para optimizar la experiencia del usuario.</li>
        </ul>
      </div>
    ),
  },
  {
    title: '4. Base jurídica del tratamiento',
    content: (
      <div className="space-y-2 text-gray-600 text-sm leading-relaxed">
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Ejecución de un contrato / medidas precontractuales</strong> (art. 6.1.b RGPD): para la prestación de los servicios de mediación solicitados.</li>
          <li><strong>Consentimiento del interesado</strong> (art. 6.1.a RGPD): para el envío de comunicaciones comerciales y el uso de cookies no esenciales.</li>
          <li><strong>Obligación legal</strong> (art. 6.1.c RGPD): para el cumplimiento de la normativa sobre mediación (Ley 5/2012) y fiscal.</li>
          <li><strong>Interés legítimo</strong> (art. 6.1.f RGPD): para el análisis de uso del sitio web y la mejora de nuestros servicios.</li>
        </ul>
      </div>
    ),
  },
  {
    title: '5. Plazo de conservación de los datos',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>Los datos se conservarán durante el tiempo estrictamente necesario para la finalidad para la que fueron recabados:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>Datos de contacto y consultas: <strong>1 año</strong> desde la última comunicación.</li>
          <li>Datos de expedientes de mediación: <strong>6 años</strong> desde la finalización del proceso (conforme a la Ley 5/2012 de Mediación y normativa fiscal).</li>
          <li>Datos para comunicaciones comerciales: hasta que el usuario retire su consentimiento.</li>
          <li>Datos de navegación (cookies analíticas): según la política de cookies.</li>
        </ul>
      </div>
    ),
  },
  {
    title: '6. Destinatarios de los datos',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>No cedemos sus datos a terceros, salvo en los siguientes supuestos:</p>
        <ul className="list-disc pl-5 space-y-2 mt-2">
          <li><strong>Obligación legal:</strong> cuando sea requerido por autoridades competentes (administraciones tributarias, juzgados, etc.).</li>
          <li><strong>Proveedores de servicios:</strong> empresas que prestan servicios de hosting, plataformas de comunicación y herramientas analíticas, con las garantías adecuadas de protección de datos.</li>
          <li><strong>Otros mediadores o co-mediadores:</strong> cuando sea necesario para la prestación del servicio y con su conocimiento previo.</li>
        </ul>
        <p className="mt-3">No realizamos transferencias internacionales de datos fuera del Espacio Económico Europeo, salvo que los proveedores de servicios tecnológicos cuenten con las garantías adecuadas conforme al RGPD.</p>
      </div>
    ),
  },
  {
    title: '7. Derechos del interesado',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>Puede ejercer los siguientes derechos en cualquier momento, de forma gratuita:</p>
        <ul className="list-disc pl-5 space-y-2 mt-2">
          <li><strong>Acceso:</strong> conocer qué datos personales tratamos sobre usted.</li>
          <li><strong>Rectificación:</strong> solicitar la corrección de datos inexactos o incompletos.</li>
          <li><strong>Supresión:</strong> solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
          <li><strong>Limitación:</strong> solicitar la restricción del tratamiento en determinadas circunstancias.</li>
          <li><strong>Portabilidad:</strong> recibir sus datos en un formato estructurado y de uso común.</li>
          <li><strong>Oposición:</strong> oponerse al tratamiento basado en interés legítimo o para fines de marketing.</li>
          <li><strong>Retirada del consentimiento:</strong> en cualquier momento, sin efecto retroactivo.</li>
        </ul>
        <p className="mt-3">Para ejercer sus derechos, puede dirigirse a <a href="mailto:jlarrache@mediatioglobal.com" className="text-[#3D9E8C] hover:underline">jlarrache@mediatioglobal.com</a> indicando el derecho que desea ejercer y adjuntando una copia de su documento de identidad.</p>
        <p className="mt-2">Asimismo, tiene derecho a presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> — <a href="https://www.aepd.es" rel="nofollow" className="text-[#3D9E8C] hover:underline">www.aepd.es</a>.</p>
      </div>
    ),
  },
  {
    title: '8. Seguridad de los datos',
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        Hemos adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que están expuestos, de conformidad con el RGPD y la LOPDGDD.
      </p>
    ),
  },
  {
    title: '9. Confidencialidad en la mediación',
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        De conformidad con el artículo 9 de la Ley 5/2012, de 6 de julio, de Mediación en Asuntos Civiles y Mercantiles, el mediador está obligado a guardar confidencialidad sobre toda la información derivada del procedimiento de mediación. Esta obligación se extiende a las partes intervinientes y, en su caso, a las personas que participen en el procedimiento.
      </p>
    ),
  },
];

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-[#F4F7FA] flex flex-col">
      <LegalNavbar />
      <main className="flex-1">
        {/* Hero */}
        <section className="bg-[#1B3A5C] py-14">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#3D9E8C] mb-3">Información Legal</span>
            <h1 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-3">Política de Privacidad</h1>
            <p className="text-white/60 text-sm">Última actualización: 23 de marzo de 2026</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-14">
          <div className="max-w-4xl mx-auto px-6">
            {/* Intro card */}
            <div className="bg-[#3D9E8C]/10 border border-[#3D9E8C]/20 rounded-lg p-5 mb-6 flex gap-4 items-start">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#3D9E8C]/20 flex-shrink-0 mt-0.5">
                <i className="ri-shield-check-line text-[#3D9E8C] text-lg" />
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                En <strong className="text-[#1B3A5C]">Mediatio Global</strong> nos comprometemos a proteger su privacidad. Esta política explica cómo recogemos, usamos y protegemos su información personal de acuerdo con el RGPD y la LOPDGDD.
              </p>
            </div>

            <div className="bg-white rounded-lg overflow-hidden">
              {SECTIONS.map((section, i) => (
                <div key={i} className={`px-8 py-7 ${i !== SECTIONS.length - 1 ? 'border-b border-gray-100' : ''}`}>
                  <h4 className="font-semibold text-[#1B3A5C] text-base mb-4">
                    <a id={`privacidad-seccion-${i + 1}`} href={`#privacidad-seccion-${i + 1}`}>{section.title}</a>
                  </h4>
                  {section.content}
                </div>
              ))}
            </div>

            {/* Contact box */}
            <div className="mt-8 bg-[#1B3A5C]/5 border border-[#1B3A5C]/10 rounded-lg p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#3D9E8C]/15 flex-shrink-0">
                <i className="ri-mail-line text-[#3D9E8C] text-lg" />
              </div>
              <div>
                <p className="text-sm font-semibold text-[#1B3A5C]">¿Tienes preguntas sobre el tratamiento de tus datos?</p>
                <p className="text-xs text-gray-500 mt-0.5">Escríbenos a <a href="mailto:jlarrache@mediatioglobal.com" className="text-[#3D9E8C] hover:underline">jlarrache@mediatioglobal.com</a> o llámanos al <a href="tel:+34696342047" className="text-[#3D9E8C] hover:underline">(+34) 696 342 047</a></p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <LegalFooter />
    </div>
  );
}
